import axios from 'axios';
import Cookies from 'js-cookie';
import isBot from 'isbot';
import euCountriesList from '../utils/euCountriesList.js';

/**
 * Redirects a customer depending on their geo-location.
 *
 * @param shopifyCountry 
 */

const DOES_NOT_WANT_REDIRECT_COOKIE_MESSAGE = 'Stay on current site';

const setRedirectCookie = (message) => {
  Cookies.set('has_redirected', message);
}

const redirect = (storeUrl) => {
  window.location.hostname = storeUrl;
  setRedirectCookie(true);
}

const hideRedirectPopup = (locationElement) => {
  document.querySelector('body').setAttribute('data-modal-triggered', '');
  locationElement.classList.remove('show');
  locationElement.classList.add('hide');
  setRedirectCookie(DOES_NOT_WANT_REDIRECT_COOKIE_MESSAGE);
}

const redirectBtnEventListener = (locationElement, storeUrl) => {
  locationElement.querySelector('.location-content-redirect-btn')
    .addEventListener('click', () => {
      redirect(storeUrl)
    });
}

const hideRedirectPopupEventListener = (locationElement) => {
  locationElement.querySelector('.location-content-close-redirect-popup-btn')
    .addEventListener('click', () => {
      hideRedirectPopup(locationElement);
    });
}

const addRedirectPopupEventListeners = (locationElement, storeUrl) => {
  redirectBtnEventListener(locationElement, storeUrl);
  hideRedirectPopupEventListener(locationElement);
}

const showRedirectPopup = (storeUrl) => {
  const locationContent = document.querySelector(`[data-redirect-url="${storeUrl}"]`);
  document.querySelector('body').setAttribute('data-modal-triggered', 'redirect-popup');
  locationContent.classList.add('show');
  addRedirectPopupEventListeners(locationContent, storeUrl);
}

const redirectHandler = (shopifyCountry): void => {
  const struct = [
    {
      location: ['us.muc-off.com'],
      target: ['United States', 'United+States', 'Canada']
    },
    {
      location: ['muc-off.com'],
      target: ['United+Kingdom', 'United Kingdom']
    },
    {
      location: ['eu.muc-off.com'],
      target: euCountriesList
    }
  ];

  for (let i = 0; i < struct.length; i++) {
    const locations = struct[i].location;
    const target = struct[i].target;

    if (target.indexOf(shopifyCountry) > -1 && locations.indexOf(window.location.hostname) === -1) {
      showRedirectPopup(locations[0]);
      break;
    }
  }
}


export const initCountryRedirect = (): void => {
  if (window['theme'].isLive !== true) return;

  // Have we redirected before or we're a bot?
  if (!Cookies.get('has_redirected') && !isBot(navigator.userAgent)) {

    // Have we got shopify's country cookie?
    if (Cookies.get('_shopify_country')) {
      redirectHandler(Cookies.get('_shopify_country'));
    } else {
      // No cookie? No problem
      axios.get('https://get.geojs.io/v1/ip/country.json')
        .then(response => {
          if (response.data && response.data.name)
            redirectHandler(response.data.name);
        })
        .catch(e => console.error(e));
    }
  }
}
